<template>
    <div class="grid grid-cols-9 gap-1 justify-start border border-gray-300 rounded-md relative lg:col-span-2"
        style="height: 44px">
        <span class="el-form-item__label absolute -top-2 right-2 leading-none bg-white">
            {{ $t('LICENSE_PLATE') }}
        </span>
        <el-form-item prop="license_plate_4" class=" mb-0 left-inputs col-span-2" style=" height: 40px">
            <el-input :disabled="disabled" type="text" @input="$emit('licensePlate4', toEnglish(licenseplate4))"
                v-model="licenseplate4" autocomplete="off" maxlength="2" minlength="2" placeholder="22"
                class="two-charachters border-l border-gray-100"></el-input>
        </el-form-item>
        <el-form-item prop="license_plate_3" class=" mb-0 left-inputs col-span-3" style=" height: 40px">
            <el-input :disabled="disabled" type="text" @input="$emit('licensePlate3', toEnglish(licenseplate3))"
                v-model="licenseplate3" autocomplete="off" maxlength="3" minlength="3" placeholder="222"
                class="three-charachters border-none"></el-input>
        </el-form-item>

        <el-form-item v-loading="alphaLoading" prop="license_plate_letter" class=" mb-0 left-inputs col-span-1"
            style=" height: 40px">
            <el-select :disabled="disabled" :placeholder="$t('LETTER')"
                @change="$emit('licensePlateLetter', licenseplateletter)" v-model="licenseplateletter" clearable filterable
                class="border--0">
                <el-option v-for="item in alphaList" :key="item.code" :label="item.char" :value="item.code">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="license_plate_1" class=" mb-0 left-inputs col-span-2" style=" height: 40px">
            <el-input :disabled="disabled" @input="$emit('licensePlate1', toEnglish(licenseplate1))" v-model="licenseplate1"
                type="text" autocomplete="off" maxlength="2" minlength="2" placeholder="22"
                class="two-charachters border-none"></el-input>
        </el-form-item>
        <div class="col-span-1 bg-blue-900 border-r border-gray-300 rounded-l-md"></div>
    </div>
</template>
<script>
import { licenseChars } from "@/api/global";

export default {
    props: ['disabled', 'license_plate_4', 'license_plate_3', 'license_plate_letter', 'license_plate_1'],
    data() {
        return {
            alphaList: [
                {
                    code: "",
                    char: "",
                    id: "",
                },
            ],
            alphaLoading: true,
            licenseplate4: this.license_plate_4,
            licenseplate3: this.license_plate_3,
            licenseplate1: this.license_plate_1,
            licenseplateletter: this.license_plate_letter
        }
    },
    created() {
        licenseChars.api().then(res => {
            this.alphaList = res;
            this.alphaLoading = false;
        })
    },
    watch: {
        license_plate_4(val) {
            this.licenseplate4 = val;
        },
        license_plate_3(val) {
            this.licenseplate3 = val;
        },
        license_plate_1(val) {
            this.licenseplate1 = val;
        },
        license_plate_letter(val) {
            this.licenseplateletter = val
        }
    },
}
</script>